import axiosInstance from "./axiosInstance";

export interface BufferConfigApi {
  publicId: string;
  type: string; // "1" = accommodation, "2" = transport
  venueId: number;
  venueName: string;
  portId: number | null;
  portName: string | null;
  checkInBuffer: string;
  checkOutBuffer: string;
  description: string;
  isActive: boolean;
}

export interface BufferConfigListResponse {
  items: BufferConfigApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
  pageNumber: number;
}

export interface VenueApi {
  venueId: number;
  venueName: string;
  contactNo: string;
  emailAddress: string;
  description: string;
  timeZone: string;
  isActive: boolean;
}

export interface PortApi {
  portId: number;
  publicId: string;
  portName: string;
  portNameArabic: string;
  portShortName: string;
  arrivalShortName: string;
  departureShortName: string;
  isActive: boolean;
  deletedBy: string | null;
  deletedAt: string | null;
}

export interface CreateBufferPayload {
  type: number; // 1 = accommodation, 2 = transport
  venueId: number;
  portId: number | null;
  checkInBuffer: string;
  checkOutBuffer: string;
  description: string;
  isActive: boolean;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getBufferConfigurations = async (
  type?: number,
  pageNo = 1,
  pageSize = 20
): Promise<BufferConfigListResponse> => {
  const url = type
    ? `/buffer-configuration/list?Type=${type}&PageNo=${pageNo}&PageSize=${pageSize}`
    : `/buffer-configuration/list?PageNo=${pageNo}&PageSize=${pageSize}`;

  const res = await axiosInstance.get(url, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getVenues = async (): Promise<VenueApi[]> => {
  const res = await axiosInstance.get("/Venues?onlyActive=true", {
    headers: getAuthHeader(),
  });

  return res.data; 
};

export const getPorts = async (): Promise<PortApi[]> => {
  const res = await axiosInstance.get("/Ports", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const createBufferConfiguration = async (
  payload: CreateBufferPayload
) => {
  const res = await axiosInstance.post(
    "/buffer-configuration/create",
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const toggleBufferStatus = async (
  publicId: string,
  isActive: boolean
) => {
  const res = await axiosInstance.patch(
    `/buffer-configuration/${publicId}/active`,
    { isActive },
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const updateBufferConfiguration = async (
  publicId: string,
  payload: CreateBufferPayload
) => {
  const res = await axiosInstance.put(
    `/buffer-configuration/${publicId}`,
    {
      publicId,
      ...payload,
    },
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deleteBufferConfiguration = async (publicId: string) => {
  const res = await axiosInstance.delete(
    `/buffer-configuration/${publicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};